<template>
  <AuthButtons
    v-if="!authStore.isAuthenticated"
  />
  <UserMenu
    v-else
    :username="authStore.user?.username || ''"
    :logout-url="logoutUrl || '#'"
    :variant="userMenuVariant"
  />
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import { useOryLogout } from '@/composables/useOryLogout'
import { computed } from 'vue'
import AuthButtons from './AuthButtons.vue'
import UserMenu from './UserMenu.vue'

interface Props {
  variant?: 'light' | 'dark'
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'dark'
})

const authStore = useAuthStore()
const { logoutUrl } = useOryLogout()

const userMenuVariant = computed(() => {
  return props.variant === 'dark' ? 'default' : props.variant
})
</script>